import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'test-emails'
const verb = 'post'

export default class OspreySendRecepients extends BaseAction {
    constructor(dataKey) {
        const id = '5ff40a54-009d-4198-b432-941312b2c09f'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    send(params, contextOrn) {
        this.path = `/${resource}?X-Context-Orn=${contextOrn}`
        this.params = params
        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/test-send/test-send-mail.js